import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "loading-spinner" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-whistle",
  "aria-hidden": "true"
}, null, -1)

import { computed } from 'vue';
import { useStore } from 'vuex';
import { AppStore } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheLoadingSpinner',
  setup(__props) {

const store = useStore<AppStore>();

const loading = computed(() => store.state.loadingCount > 0);

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loading-wrapper", {loading: loading.value}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives((_openBlock(), _createElementBlock("p", null, [
        _createTextVNode("Laddar...")
      ])), [
        [_directive_translate]
      ])
    ])
  ], 2))
}
}

})